var variantSelectorLoadedProducts = {};
var VariantSelectorProductLoader = class {
  static load(productHandle) {
    if (!productHandle) {
      return;
    }
    if (variantSelectorLoadedProducts[productHandle]) {
      return variantSelectorLoadedProducts[productHandle];
    }
    variantSelectorLoadedProducts[productHandle] = new Promise(async (resolve, reject) => {
      const response = await fetch(`${Shopify.routes.root}products/${productHandle}.js`);
      if (response.ok) {
        const responseAsJson = await response.json();
        resolve(responseAsJson);
      } else {
        reject(`
          Attempted to load information for product with handle ${productHandle}, but this product is in "draft" mode. You won't be able to
          switch between variants or access to per-variant information. To fully preview this product, change temporarily its status
          to "active".
        `);
      }
    });
    return variantSelectorLoadedProducts[productHandle];
  }
};

var VariantSelector = class extends HTMLElement {
  constructor() {
    super(...arguments);
    this.abortController = new AbortController()
  }

  async connectedCallback() {
    this.masterSelector = document.forms[this.getAttribute("form")].id;
    this.optionSelectors = Array.from(this.querySelectorAll("[data-option-selector]"));
    this.optionSelectors.forEach((optionSelector) => {
      optionSelector.addEventListener("change", this.onOptionChange.bind(this), { signal: this.abortController.signal });
    });
    this.product = await VariantSelectorProductLoader.load(this.productHandle);

    document.getElementsByName("input").forEach((i) => {
      if((i.name === "size-option" || i.name == "amount-option") && i.checked) {
        this.selectVaiant(i.value)
      }
    })
  }

  get productHandle() {
    return this.getAttribute("handle");
  }

  disconnectedCallback() {
    this.abortController.abort();
  }

  onOptionChange (event) {
    if (!event.target.name.startsWith("size-option") &&  !event.target.name.startsWith("amount-option")) {
        return;
    }
    this.selectVariant(event.target.value);
  }

  selectVariant(id) {
    this.masterSelector.value = id;
    this.masterSelector.dispatchEvent(new Event("change", { bubbles: true }));
    if (history.replaceState) {
      const newUrl = new URL(window.location.href);
      if (id) {
        newUrl.searchParams.set("variant", id);
      } else {
        newUrl.searchParams.delete("variant");
      }
      window.history.replaceState({ path: newUrl.toString() }, "", newUrl.toString());
    }
    this.masterSelector.form.dispatchEvent(new CustomEvent("variant:change", {
      bubbles: true,
      detail: {
        product: this.product,
        variant: this.product.variants.find((variant) => variant.id == id),
        previousVariant: ""
      }
    }));
  }
};

var VariantSelectortOptionValue = class extends HTMLElement {
  constructor() {
    super(...arguments);
  }
  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener("variant:change", this.onVariantChanged.bind(this));
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener("variant:change", this.onVariantChanged.bind(this));
  }
  onVariantChanged = function(event) {
    this.innerHTML = event.detail.variant.options[parseInt(this.getAttribute("for"))]
  };
};

if (!window.customElements.get("variant-selector-option-value")) {
  window.customElements.define("variant-selector-option-value", VariantSelectortOptionValue);
}
if (!window.customElements.get("variant-selector")) {
  window.customElements.define("variant-selector", VariantSelector);
}